<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filter.endtCode" :label="labels.endtCode" data-vv-name="endtCode" :data-vv-as="labels.endtCode" :error-messages="errors.collect('endtCode')"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filter.endtCodeDesc" :label="labels.endtCodeDesc" data-vv-name="endtCodeDesc" :data-vv-as="labels.endtCodeDesc" :error-messages="errors.collect('endtCodeDesc')"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNew">
            New Endorsement Code
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" :footer-props="{'items-per-page-options': itemsPerPage }" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.endtCode }}</td>
                <td class="text-xs-left">{{ row.item.endtCodeDesc }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item)" query @query="doQuery(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <!--Start Dialog Reivew-->
      <v-dialog v-model="reviewDialog" width="800px" persistent>
        <v-card>
          <v-toolbar v-if="queryMode" dense color="grey lighten-3" flat>
            <v-icon>mdi-magnify</v-icon>
            <v-toolbar-title>{{labels.queryMode}}</v-toolbar-title>
          </v-toolbar>
          <v-toolbar v-if="reviewMode" dense color="grey lighten-3" flat>
            <v-icon>mdi-magnify</v-icon>
            <v-toolbar-title>{{labels.reviewMode}}</v-toolbar-title>
          </v-toolbar>
          <v-toolbar v-if="newMode" dense color="grey lighten-3" flat>
            <v-icon>mdi-plus</v-icon>
            <v-toolbar-title>{{labels.newMode}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6 v-if="newMode">
                  <v-text-field :label="labels.endtCode" v-model="form.endtCode" :error-messages="errors.collect('endtCode')" data-vv-name="endtCode" :data-vv-as="labels.endtCode"  v-validate="'required|param|max:2'"></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{labels.endtCode}}</v-subheader>
                  <div class="queryValue">{{form.endtCode}}</div>
                </v-flex>
                <v-flex xs6 v-if="queryMode">
                  <v-subheader class="queryLabel">{{labels.endtCodeDesc}}</v-subheader>
                  <div class="queryValue">{{form.endtCodeDesc}}</div>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-text-field :label="labels.endtCodeDesc" v-model="form.endtCodeDesc" :error-messages="errors.collect('endtCodeDesc')" data-vv-name="endtCodeDesc" :data-vv-as="labels.endtCodeDesc"  v-validate="'required|max:30'"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.createdBy}}</v-subheader>
                  <div class="queryValue">{{form.createdBy}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
                  <div class="queryValue">{{formatDisplayDate(form.createdDate)}}</div>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if="!newMode">
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.modifiedBy}}</v-subheader>
                  <div class="queryValue">{{form.modifiedBy}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.modifiedDate}}</v-subheader>
                  <div class="queryValue">{{formatDisplayDate(form.modifiedDate)}}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="doClose">Cancel</v-btn>
            <v-btn v-show="!queryMode" color="primary" text @click.native="doSave" :loading="submitting">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- End Review Dialog -->
      <!--Start Delete Prompt -->
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>{{labels.promptRemove}}</p>
        <div class="queryValue">{{selected.endtCode}} - {{selected.endtCodeDesc}}</div>
      </confirm>
      <!-- End Delete Prompt-->
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { formatDisplayDate } from '@/utils/date'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Cancellation Code',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'cancelCode' }
        },
        {
          text: 'GIRO BIC',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'giroBank' }
        }
      ],
      toogleArray: [false],
      loading: false,
      submitting: false,
      totalItems: 0,
      headers: [
        { text: 'Endorsement Code', value: 'endtCode' },
        { text: 'Endorsement Code Description', value: 'endtCodeDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        endtCode: 'Endorsement Code',
        endtCodeDesc: 'Endorsement Code Description',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        queryMode: 'Query Endorsement Code',
        reviewMode: 'Edit Endorsement Code',
        newMode: 'Create New Endorsement Code',
        promptRemove: 'Are you sure you want to delete the selected Endorsement Code?'
      },
      form: {
        endtCode: null,
        endtCodeDesc: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      selected: {
        endtCode: null,
        endtCodeDesc: null
      },
      filter: {
        endtCode: undefined,
        endtCodeDesc: undefined
      },
      promptRemove: false,
      queryMode: false,
      reviewMode: false,
      reviewDialog: false,
      newMode: false,
      today: new Date(),
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    this.fetchData(true)
    this.doInit()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getEndtCodeList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  endtCode: datamap.endtCode,
                  endtCodeDesc: datamap.endtCodeDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.form.endtCode = null
      this.form.endtCodeDesc = null
      this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.form.createdDate = new Date()
      this.form.modifiedBy = null
      this.form.modifiedDate = null
      this.queryMode = false
      this.reviewMode = false
      this.newMode = true
      this.reviewDialog = true
    },
    doQuery(data) {
      this.queryMode = true
      this.reviewMode = false
      this.newMode = false
      this.doFetchData(data)
    },
    doReview(data) {
      this.queryMode = false
      this.newMode = false
      this.reviewMode = true
      this.doFetchData(data)
    },
    doFetchData(data) {
      this.resetValidator()
      this.resetMessages()
      if (data) {
        const apiURI = this.menu.getEndtCode
        const expand = {
          endtCode: data.endtCode,
          endtCodeDesc: data.endtCodeDesc
        }
        if (apiURI) {
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              const { data } = result.data
              if (data) {
                this.form.endtCode = data.endtCodeData.endtCode
                this.form.endtCodeDesc = data.endtCodeData.endtCodeDesc
                this.form.createdBy = data.createdBy
                this.form.createdDate = data.createdDate
                this.form.modifiedBy = data.modifiedBy
                this.form.modifiedDate = data.modifiedDate
                this.reviewDialog = true
              }
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        this.promptRemove = true
        this.selected.endtCode = data.endtCode
        this.selected.endtCodeDesc = data.endtCodeDesc
      }
    },
    async doDelete() {
      if (this.selected && this.selected.endtCode) {
        const apiURI = this.menu.deleteEndtCode
        if (apiURI) {
          const expand = {
            endtCode: this.selected.endtCode,
            endtCodeDesc: this.selected.endtCodeDesc
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData(false)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.form.endtCode = null
      this.form.endtCodeDesc = null
      this.reviewDialog = false
      setTimeout(() => {
        this.newMode = false
        this.queryMode = false
        this.reviewMode = false
      }, 200)
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
          } else {
            // doNothing here
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createEndtCode
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClose()
            this.fetchData(false)
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateEndtCode
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClose()
            this.fetchData(false)
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.endtCode = undefined
      this.filter.endtCodeDesc = undefined
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.resetValidator()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  },
  computed: {
    menu() {
      return this.$store.state.endtCode.menu
    }
  },
  components: {
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
